import { useState } from "react";
import {
  NOTIFICATION_FALLBACK_IMAGE,
  getNotificationAvatar,
  getNotificationInitials,
} from "../utils/notifications";

/**
 * The image beside a notification, shared by the user drawer, the assistant
 * dashboard and the admin panel so the three can't drift apart.
 *
 * Order of preference: the actor's real photo, their initials, then the Pulo
 * mark. A notification that is not about a person — a profile review, say —
 * has no actor and goes straight to the mark. Nothing here ever shows a photo
 * of someone unrelated to the notification.
 */
function NotificationAvatar({ notification, className = "h-12 w-12" }) {
  const [failed, setFailed] = useState(false);

  const avatarUrl = getNotificationAvatar(notification);
  const initials = getNotificationInitials(notification);
  const actorName = notification?.actor?.name || "";

  if (avatarUrl && !failed) {
    return (
      <img
        src={avatarUrl}
        alt={actorName}
        onError={() => setFailed(true)}
        className={`${className} shrink-0 rounded-lg object-cover`}
      />
    );
  }

  if (initials) {
    return (
      <span
        aria-label={actorName}
        title={actorName}
        className={`${className} flex shrink-0 items-center justify-center rounded-lg bg-[#F2E4EC] text-sm font-semibold text-[#7A0147]`}
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      src={NOTIFICATION_FALLBACK_IMAGE}
      alt=""
      className={`${className} shrink-0 rounded-lg object-contain`}
    />
  );
}

export default NotificationAvatar;
